import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgForward(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="5 0 14 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.595 12l-5.07-5-1.448 1.429 2.594 2.561H6.305v2.02h8.366l-2.594 2.561L13.525 17l5.07-5z"
        fill="currentColor"
      />
    </svg>
  );
}

export default tombacIcon('Forward')(SvgForward);
